import { useAppContext, stringifyPublisher } from '@provider/app-context';
import { PublisherLogo } from '@ui/kit/icons';
import { wrapper, logo, textWrapper } from './print.header.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function PrintHeader() {
  const publisher = useAppContext(state => state.publisher);
  const product = useAppContext(state => state.product);
  const course = useAppContext(state => state.course);
  const title = `${stringifyPublisher(publisher)}s fagportaler`;
  const productLabel = product?.subject ? `${product.subject}${product.gradesLabel ? ` ${product.gradesLabel}` : ""}${product.classLabel ? ` ${product.classLabel}` : ""}` : product?.title;
  return /*#__PURE__*/jsxs("header", {
    "aria-hidden": true,
    className: wrapper,
    children: [/*#__PURE__*/jsx(PublisherLogo, {
      className: logo,
      small: true
    }), /*#__PURE__*/jsxs("div", {
      className: textWrapper,
      children: [/*#__PURE__*/jsx("b", {
        children: title
      }), product ? /*#__PURE__*/jsxs(Fragment, {
        children: [" ", "| ", /*#__PURE__*/jsxs("span", {
          children: [" ", productLabel, " |"]
        }), /*#__PURE__*/jsxs("span", {
          children: [" ", "Arbejdsark", course?.title ? /*#__PURE__*/jsxs(Fragment, {
            children: [" ", "til ", /*#__PURE__*/jsx("b", {
              children: course.title
            })]
          }) : ""]
        })]
      }) : ""]
    })]
  });
}

export { PrintHeader };
//# sourceMappingURL=print.header.js.map
